module.exports = __webpack_public_path__ + "img/camera-symbol.86cd1394.jpg";